import { MapContentLayer } from '../MapContentLayer';
import { CircleLayerSpecification, LayerSpecification } from 'maplibre-gl';
import { MapContentSource } from '../MapContentSource';

export class ShiftMarkerShadowLayer extends MapContentLayer {

  constructor(
    source: MapContentSource
  ) {
    super('shift-marker-shadow-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'circle',
      source: this.sourceRef.sourceId,
      paint: {
        'circle-radius': 18,
        'circle-color': '#000',
        'circle-blur': 0.75,
        'circle-translate': [2, 2],
      },
    } as CircleLayerSpecification;
  }

}
